export default function Contact() {
  const handleWhatsAppClick = (phone: string, message: string) => {
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/${phone}?text=${encodedMessage}`, '_blank');
  };

  const handlePhoneClick = (phone: string) => {
    window.open(`tel:${phone}`, '_self');
  };

  const handleLocationClick = () => {
    window.open('https://maps.app.goo.gl/1j2NKJAJEtBS99Mx5', '_blank');
  };

  return (
    <section id="contacto" className="py-24 bg-gradient-to-b from-[#F5E6D3] to-[#E8D4B8]">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-serif font-bold text-[#5D4037] mb-6">
            ¿Listo para tu Proyecto?
          </h2>
          <p className="text-xl text-gray-700">
            Cotiza directamente por WhatsApp y recibe asesoría inmediata
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          {/* Contacto Central */}
          <div className="bg-white/80 rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <i className="ri-building-line text-3xl text-[#5D4037]"></i>
              <h3 className="text-2xl font-bold text-[#5D4037]">Número Central</h3>
            </div>
            <button
              onClick={() => handleWhatsAppClick('56981372039', 'Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.')}
              className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-5 rounded-full text-lg font-bold shadow-xl hover:scale-105 transition-transform duration-300 mb-4 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-3xl"></i>
              +56 9 8137 2039
            </button>
            <p className="text-center text-gray-600 text-sm">
              O llámanos al{' '}
              <button onClick={() => handlePhoneClick('+56981372039')} className="text-[#5D4037] font-bold hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">
                +56 9 8137 2039
              </button>
            </p>
          </div>

          {/* Vendedor Directo */}
          <div className="bg-white/80 rounded-2xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <i className="ri-user-line text-3xl text-[#5D4037]"></i>
              <h3 className="text-2xl font-bold text-[#5D4037]">Vendedor Directo</h3>
            </div>
            <button
              onClick={() => handleWhatsAppClick('56974838794', 'Hola, quiero cotizar productos de madera con Aserradero Santa Rosa.')}
              className="w-full flex items-center justify-center gap-3 bg-[#25D366] text-white px-8 py-5 rounded-full text-lg font-bold shadow-xl hover:scale-105 transition-transform duration-300 mb-4 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-3xl"></i>
              +56 9 7483 8794
            </button>
            <p className="text-center text-gray-600 text-sm">
              O llámanos al{' '}
              <button onClick={() => handlePhoneClick('+56974838794')} className="text-[#5D4037] font-bold hover:text-[#D4AF37] transition-colors cursor-pointer whitespace-nowrap">
                +56 9 7483 8794
              </button>
            </p>
          </div>
        </div>

        {/* Horarios y Ubicación */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Horarios */}
          <div className="bg-white/70 rounded-2xl p-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-time-line text-3xl text-[#5D4037]"></i>
              <h3 className="text-2xl font-bold text-[#5D4037]">Horarios de Atención</h3>
            </div>
            <div className="space-y-2 text-lg text-gray-700">
              <p className="font-semibold">Lunes a Viernes: 8:30 - 18:00 hrs</p>
              <p className="font-semibold">Sábados: 8:30 - 13:00 hrs</p>
            </div>
          </div>

          {/* Ubicación */}
          <div className="bg-white/70 rounded-2xl p-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <i className="ri-map-pin-line text-3xl text-[#5D4037]"></i>
              <h3 className="text-2xl font-bold text-[#5D4037]">Nuestra Ubicación</h3>
            </div>
            <p className="text-lg text-gray-700 mb-4 font-semibold">Región del Maule, Chile</p>
            <button
              onClick={handleLocationClick}
              className="inline-flex items-center gap-2 bg-[#5D4037] text-white px-6 py-3 rounded-full font-semibold hover:bg-[#D4AF37] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-map-2-line text-xl"></i>
              Ver en Google Maps
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
